<template>
    <div class="languages">
      <h2>Uzmanlık Dillerim</h2>
      <textarea v-model="languages" placeholder="Örn: İngilizce, Almanca" rows="4" />
      <button class="btn primary" @click="updateLanguages">Kaydet</button>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue'
  import { getToken } from '@/utils/auth'
  const baseURL = process.env.VUE_APP_API_URL
  const languages = ref('')
  
  onMounted(async () => {
    const res = await fetch(`${baseURL}/settings/profile`, {
      headers: { Authorization: `Bearer ${getToken()}` }
    })
    const data = await res.json()
    languages.value = data.languages || ''
  })
  
  async function updateLanguages() {
    const res = await fetch(`${baseURL}/settings/languages`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`
      },
      body: JSON.stringify({ languages: languages.value })
    })
  
    const data = await res.json()
    if (res.ok) {
      alert(data.message || 'Diller güncellendi.')
    } else {
      alert(data.message || 'Hata oluştu.')
    }
  }
  </script>
  
  <style scoped>
  .languages {
    max-width: 600px;
    margin: auto;
  }
  textarea {
    width: 100%;
    padding: 10px;
    border-radius: 6px;
    border: 1px solid #ccc;
  }
  .btn.primary {
    margin-top: 10px;
    padding: 10px 20px;
    background-color: #0c2d57;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
  }
  </style>
  
